import * as React from "react";
import { Strings } from '--root/strings/en';
import { getYears, getMonths, getDiffMonths, getDiffYears } from "../utils";
import VirtualScroll from "./VirtualScroll";
import styled from "styled-components";

const STRINGS = Strings.dateTime;

type DateSidebarProps = {
    type: "month"|"year"
    short?: boolean
    min: Date
    max: Date
    onClick?: (date: Date)=>void
    active?: Date
    style?: React.CSSProperties
}

const DateSidebar: React.FC<DateSidebarProps> = props => {
    const { type, short, onClick, min, max, active, style } = props;
    
    const itemHeight = 32;
    const items = type=="month" ? getMonths(min, max) : getYears(min, max);
    const getDiff = type=="month" ? getDiffMonths : getDiffYears;
    const activeIndex = getDiff(min, active || new Date());
    const scrollTop = activeIndex * itemHeight;

    return <StyledDateSidebar>
        <VirtualScroll 
            items={items}
            itemHeight={itemHeight} 
            renderer={(item, idx) => <Label item={item as Date} type={type} short={short} active={idx==activeIndex} onClick={onClick} />}
            scrollTop={scrollTop}
            center
            style={style} />
    </StyledDateSidebar>
};
const StyledDateSidebar = styled.div`
    height: 100%;
    position: relative;
    border-right: 1px solid ${props => props.theme.palette.ui.border};
`;

type LabelProps = {
    type: "year"|"month"
    item: Date
    short?: boolean
    active?: boolean
    onClick?: (date: Date) => void
}
const Label:React.FC<LabelProps> = (props) => {
    const { type, item, short, active, onClick } = props;
    let label: string;
    let major = false;
    if (type == "year" || item.getMonth() == 0) {
        label = `${item.getFullYear()}`;
        major = type == "year" ? item.getFullYear() % 10 == 0 : true;
    } else {
        label = short ? 
            STRINGS.monthsShort[item.getMonth()]! : 
            STRINGS.months[item.getMonth()]!;
    }

    return <StyledLabel onClick={() => onClick && onClick(item)} major={major} active={active}>{label}</StyledLabel>
}
type StyledLabelProps = {
    major?: boolean
    active?: boolean
}
const StyledLabel = styled.div<StyledLabelProps>`
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    ${props => props.theme.typography.body2};
    font-weight: ${props => (props.major || props.active) ? props.theme.typography.bold : 'initial'};
    color: ${props => (props.major || props.active) ? props.theme.palette.text.primary : props.theme.palette.text.secondary};
    margin: 0;
    display: flex;
    align-items: center;
    padding: ${props => props.theme.spacing(0, 1)};
    background: ${props => props.active ? props.theme.palette.ui.highlight : "initial"};
    border-radius: ${props => `${props.theme.radius.small} 0 0 ${props.theme.radius.small}`};
    cursor: ${props => props.onClick ? "pointer" : "initial"};
`;

export default DateSidebar;
export { DateSidebar, DateSidebarProps };